// libraries
import sanitizeHtml from 'sanitize-html'
// components
import InputTextarea from '../../../atoms/input-textarea/input-textarea'
import Button from '../../../atoms/button/button'

const FormTextExperience = props => {
	const { value, action, sendData, buttonText, placeholder, required } = props

	return (
		<form>
			<InputTextarea
				placeholder={placeholder || 'Escribe aquí…'}
				value={value || ''}
				change={e => action({ value: sanitizeHtml(e.target.value), key: 'textAnswer' })}
				maxlength={200}
			/>
			{buttonText && (
				<Button
					uppercase
					disabled={!value && required}
					title={buttonText}
					classes='pink'
					onClick={() => sendData()}
				/>
			)}
		</form>
	)
}

export default FormTextExperience
